<template>
  <div id="index">
    <div class="index-content">
      {{ content }}
    </div>
    <div class="index-list">
      <div class="index-item" style="margin-top: 50px;">
        <div class="index-item-index" @click="forwardEngineer">
          <div class="index-item-img">
            <img src="@/assets/index-urgent-repair.png" alt="img"/>
          </div>
          <div class="index-item-title">订单</div>
        </div>
        <div class="index-item-index" @click="forwardReport">
          <div class="index-item-img">
            <img src="@/assets/report-list.png" alt="img"/>
          </div>
          <div class="index-item-title">报告汇总列表</div>
        </div>
        <!--<div class="index-item-index" @click="forwardWorker">
          <div class="index-item-img">
            <img src="@/assets/index-regular-repair.png" alt="img"/>
          </div>
          <div class="index-item-title">维修单工人</div>
        </div>-->
      </div>
      <div class="index-item">
        <div class="index-item-index" @click="forwardWorkers('cooperation')">
          <div class="index-item-img">
            <img src="@/assets/worker-relation.png" alt="img" style="height: 32px;"/>
          </div>
          <div class="index-item-title">施工人员信息</div>
        </div>
        <div class="index-item-index" @click="showReimbursementList">
          <div class="index-item-img">
            <img src="@/assets/index-waiting-receive.png" alt="img"/>
          </div>
          <div class="index-item-title">报销汇总列表</div>
        </div>
        <!--<div class="index-item-index" @click="forwardList('appointed')">
          <div class="index-item-img">
            <img src="@/assets/index-repair-list.png" alt="img"/>
          </div>
          <div class="index-item-title">待接受</div>
        </div>-->
        <!--<div class="index-item-index" @click="createOrder">
          <div class="index-item-img">
            <img src="@/assets/index-waiting-receive.png" alt="img"/>
          </div>
          <div class="index-item-title">创建订单</div>
        </div>
        <div class="index-item-index" @click="forwardWorkers('cooperation')">
          <div class="index-item-img">
            <img src="@/assets/worker-relation.png" alt="img" style="height: 32px;"/>
          </div>
          <div class="index-item-title">合作工人</div>
        </div>-->
      </div>
      <!--<div class="index-item">
        <div class="index-item-index" @click="forwardReport">
          <div class="index-item-img">
            <img src="@/assets/report-list.png" alt="img"/>
          </div>
          <div class="index-item-title">报告单</div>
        </div>
        <div class="index-item-index" @click="showReimbursementList">
          <div class="index-item-img">
            <img src="@/assets/index-waiting-receive.png" alt="img"/>
          </div>
          <div class="index-item-title">报销单列表</div>
        </div>
      </div>-->
      <div class="index-item">
        <!--<div class="index-item-index" @click="showPreReimbursementList">
          <div class="index-item-img">
            <img src="@/assets/index-waiting-receive.png" alt="img"/>
          </div>
          <div class="index-item-title">预报价列表</div>
        </div>
        <div class="index-item-index" @click="showStat">
          <div class="index-item-img">
            <img src="@/assets/index-waiting-receive.png" alt="img"/>
          </div>
          <div class="index-item-title">数据统计</div>
        </div>-->
        <!--<div class="index-item-index" @click="createOrder">
          <div class="index-item-img">
            <img src="@/assets/index-waiting-receive.png" alt="img"/>
          </div>
          <div class="index-item-title">创建订单</div>
        </div>-->
      </div>
    </div>
    <!--<van-image
      width="100%"
      height="100%"
      fit="contain"
      :src="logoPath"
    />
    <van-notice-bar
      v-if="text"
      left-icon="volume-o"
      :text="text"
    />
    <van-grid :column-num="3">
      <van-grid-item icon="description" text="维修单(负责人)" to="/warranty_list"/>
      <van-grid-item icon="description" text="维修单(工人)" to="/worker_warranty_list"/>
      <van-grid-item icon="photo-o" text="待接受" @click="forwardList(1)" />
      <van-grid-item icon="photo-o" text="已提交" @click="forwardList(2)" />
      <van-grid-item icon="photo-o" text="创建报销单" @click="showReimbursement" />
      <van-grid-item icon="photo-o" text="报销单列表" @click="showReimbursementList" />
      <van-grid-item icon="calendar-o" text="工程日历" @click="showCalendar" />
      <van-grid-item icon="records" text="创建订单" @click="createOrder" />
    </van-grid>-->
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      content: '',
      text: '欢迎使用工人端',
      logoPath: require('.././assets/logo.png')
    }
  },
  created () {
    document.title = '首页'
    if (this.$route.query.access_token) {
      // localStorage.setItem('token', 'Bearer ' + this.$route.query.access_token)
      this.$cookies.set('token', 'Bearer ' + this.$route.query.access_token)
    }
    this.checkLogin()
  },
  methods: {
    forwardReport() {
      if (this.isMobile()) {
        this.$router.push({path: '/report_list'})
        return true
      }
      this.$router.push({path: '/report_list_pc'})
    },
    forwardEngineer() {
      this.$router.push({path: '/warranty_list'})
    },
    forwardWorker() {
      this.$router.push({path: '/worker_warranty_list'})
    },
    showCalendar() {
      this.$router.push({path: '/order_calendar'})
    },
    checkLogin () {
      let token = localStorage.getItem('token')
      if (!token) {
        token = this.$cookies.get('token')
      }
      if (!token) {
        this.$router.push('/')
        return false
      }
    },
    showReimbursement() {
      if (this.isMobile()) {
        this.$router.push({path: '/order_reimbursement'})
      } else {
        this.$router.push({path: '/warranty_pc_detail', query: {showAdd: true}})
      }
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    },
    showReimbursementList() {
      if (this.isMobile()) {
        this.$router.push({path: '/order_reimbursement_list'})
      } else {
        this.$router.push({path: '/warranty_pc_detail'})
      }
    },
    showPreReimbursementList() {
      if (this.isMobile()) {
        this.$router.push({path: '/order_reimbursement_list', query: {pre_quote_status: 1}})
      } else {
        this.$router.push({path: '/warranty_pc_detail', query: {pre_quote_status: 1}})
      }
    },
    showStat() {
      this.$router.push({path: '/order_stat'})
    },
    forwardList (type) {
      this.$router.push({path: '/warranty_list', query: {status: type}})
    },
    createOrder () {
      this.$router.push({path: '/order_create'})
    },
    forwardWorkers (type) {
      this.$router.push({path: '/cooperation_workers'})
    }
  }
}
</script>

<style scoped>
.index-list {
  width: 90%;
  margin: 0 auto;
  overflow: hidden;
}
.index-content {
  margin: 20px auto;
  width: 90%;
  height: 80px;
}
.index-item-index {
  float: left;
  background: #f5f7fb;
  width: 42%;
  padding: 20px 3%;
  border-radius: 10px;
  text-align: left;
  margin-bottom: 15px;
}
.index-item div:nth-child(1) {
  margin-right: 4%;
}
.index-item-title {
  font-size: 16px;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue